import { render } from "./SwitchInput.vue?vue&type=template&id=46ed2676&scoped=true&lang=pug"
import script from "./SwitchInput.vue?vue&type=script&lang=js"
export * from "./SwitchInput.vue?vue&type=script&lang=js"

import "./SwitchInput.vue?vue&type=style&index=0&id=46ed2676&lang=scss&scoped=true"

import exportComponent from "/var/www/valley_watch_firm/fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ed2676"]])

export default __exports__